import { DATE_FORMATS } from "../../constants/date/date.js";
import { format } from "./format.js";
import "date-fns";
import "../fp/flow/flow.js";
import "./toDate.js";
import "date-fns/fp/parseISO";
const formatDefault = (date) => format(date, DATE_FORMATS.DAY_MONTH_YEAR);
export {
  formatDefault
};
